import React from 'react';
import { Helmet } from 'react-helmet-async';
import ServicesStory from '../components/ServicesStory';
import Footer from '../components/Footer';

// Preview route for the new scroll-told services section, so it can be judged
// against the live one at / without either being taken off the site. When it is
// approved, swap <OurServicesSection /> for <ServicesStory /> in App.jsx's
// HomePage and this route can go.
export default function ServicesStoryPage() {
  return (
    <>
      <Helmet>
        <title>Services Story — Zone-X</title>
        <meta name="robots" content="noindex" />
      </Helmet>

      <div style={{ height: '58vh', display: 'flex', alignItems: 'flex-end', padding: '0 clamp(20px, 4vw, 64px) 64px' }}>
        <div>
          <span style={{
            fontFamily: "'JetBrains Mono', monospace", fontSize: 11, letterSpacing: '0.2em',
            textTransform: 'uppercase', color: '#003CFF',
          }}>
            Preview build
          </span>
          <h1 style={{
            fontFamily: "'Anton', sans-serif", fontWeight: 400, margin: '14px 0 0',
            fontSize: 'clamp(32px, 6vw, 68px)', lineHeight: 1.02, textTransform: 'uppercase',
          }}>
            Services, told<br />as a story
          </h1>
          <p style={{
            marginTop: 18, maxWidth: '52ch', fontSize: 15.5, lineHeight: 1.7,
            color: 'rgba(10,10,20,0.58)',
          }}>
            Keep scrolling. Each sector arrives, opens a signal bus, and routes it
            out to the services delivered inside it — one tap at a time.
          </p>
        </div>
      </div>

      <ServicesStory />

      <div style={{ height: '30vh' }} />
      <Footer />
    </>
  );
}
